module.exports = __webpack_public_path__ + "static/sara-928245a145499cbaf27419138f209810.jpeg";